module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/coin-19cb23c25266ca66dc524ecfb5c3e5d0.svg";